export default function ($http) {
    return function (userId, model) {
        return $http({
            method: 'PUT',
            url: `/api/users/edit/${ userId }`,
            data: model,
            headers: {
                'Content-Type': 'application/json'
            }
        })
		.then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/services/edit/editUser.js